import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import config from 'constants/config'
import { pluralizeToString } from 'lib/string/pluralize'
import React from 'react'

type RoomThreshhold = 'rate' | 'default'

interface Props {
  roomCount: number;
  className?: string;
  /**
   * Threshhold at which to apply the label
   * @default default
   */
  threshold?: RoomThreshhold;
  /**
   * The kind of label that'll be shown
   * @default primary
   */
  kind?: 'primary' | 'plain'
}

function RoomsRemainingLabel(props: Props) {
  const { roomCount, className, threshold = 'default', kind = 'primary' } = props

  const minCount = threshold === 'rate' ? config.RATE_OPTION_ONLY_N_ROOMS_LEFT_THRESHOLD : config.ONLY_N_ROOMS_LEFT_THRESHOLD

  if (roomCount === 0 || roomCount > minCount) {
    return null
  }

  return <UrgencyLabel className={className} variant={kind === 'primary' ? 'critical2' : 'critical1'}>
    {pluralizeToString('room', roomCount)} left
  </UrgencyLabel>
}

export default RoomsRemainingLabel
